import { SalaryPeriod } from '../services/api/api-model';

export class ExtendSalaryPeriod extends SalaryPeriod {
  Period: string;
}
